import React, { Component } from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import {
  inject,
  observer,
} from 'mobx-react';
import { IconUnitLabel } from './components/labels';
import { AnalogUnitList } from '../../constants/DeviceModels';

class AnalogInput extends Component {
  render() {
    const { device, batchStore } = this.props;
    const moisture = batchStore.getAnalogInputValue(device.id);

    return (
      <div id={`device-${device.id}`} className={`device-gui device-gui--analog-input analog-input${moisture}`}>
        <div className="device-label device-icon">
          <div className="device-type" title={`#${device.id}`}>{device.description || `Analog Input #${device.id}`}</div>
          <IconUnitLabel value={moisture} unit={AnalogUnitList[device.unit]} icon={device.icon}/>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(inject('batchStore')(observer(AnalogInput)));
